import { render, staticRenderFns } from "./AmeldingFormAdditionalFields.vue?vue&type=template&id=1a3357ac&scoped=true&"
import script from "./AmeldingFormAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./AmeldingFormAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingFormAdditionalFields.vue?vue&type=style&index=0&id=1a3357ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3357ac",
  null
  
)

export default component.exports